import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Sentry.BrowserTracing()],
  // Capture 10% of page loads for performance tracing
  tracesSampleRate: 0.1,
  environment: process.env.NODE_ENV || 'production',
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
